import { memo } from "react";
function DisabledefaultIcon({ color = "#05A792", width, height }) {
  return (
    <svg
      width={width ??"15"}
      height={height ??"15"}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 33H33V3H3V33ZM3 36C2.16667 36 1.45833 35.7083 0.875 35.125C0.291667 34.5417 0 33.8333 0 33V3C0 2.16667 0.291667 1.45833 0.875 0.875C1.45833 0.291667 2.16667 0 3 0H33C33.8333 0 34.5417 0.291667 35.125 0.875C35.7083 1.45833 36 2.16667 36 3V33C36 33.8333 35.7083 34.5417 35.125 35.125C34.5417 35.7083 33.8333 36 33 36H3ZM9.75 26.25C10.05 26.55 10.4 26.7 10.8 26.7C11.2 26.7 11.55 26.55 11.85 26.25L18 20.1L24.15 26.25C24.45 26.55 24.8 26.7 25.2 26.7C25.6 26.7 25.95 26.55 26.25 26.25C26.55 25.95 26.7 25.6 26.7 25.2C26.7 24.8 26.55 24.45 26.25 24.15L20.1 18L26.25 11.85C26.55 11.55 26.7 11.2 26.7 10.8C26.7 10.4 26.55 10.05 26.25 9.75C25.95 9.45 25.6 9.3 25.2 9.3C24.8 9.3 24.45 9.45 24.15 9.75L18 15.9L11.85 9.75C11.55 9.45 11.2 9.3 10.8 9.3C10.4 9.3 10.05 9.45 9.75 9.75C9.45 10.05 9.3 10.4 9.3 10.8C9.3 11.2 9.45 11.55 9.75 11.85L15.9 18L9.75 24.15C9.45 24.45 9.3 24.8 9.3 25.2C9.3 25.6 9.45 25.95 9.75 26.25ZM3 33V3V33Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(DisabledefaultIcon);
